module.exports = __webpack_public_path__ + "img/83.2f8a9e6c.jpg";